// consumer-frontend/src/components/Auth/ExplainAuthenticatorDialog.tsx

import React from 'react'
import { Dialog, DialogTitle, DialogContent, Typography, Box, Stack, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import GoogleAuthenticatorLogo from '../../assets/google_authenticator.png'
import MicrosoftAuthenticatorLogo from '../../assets/microsoft_authenticator.png'
import { useTranslation } from 'react-i18next'

interface ExplainAuthenticatorDialogProps {
    open: boolean
    onClose: () => void
}

const ExplainAuthenticatorDialog: React.FC<ExplainAuthenticatorDialogProps> = ({ open, onClose }) => {
    const { t } = useTranslation()
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
                <CloseIcon />
            </IconButton>
            <DialogTitle sx={{ padding: 2 }}>{t('auth.where_is_code_title')}</DialogTitle>
            <DialogContent sx={{ padding: 2 }}>
                <Typography variant="body1" sx={{ mb: 3 }}>
                    {t('auth.code_explain_1')}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1, textAlign: 'center' }}>
                    {t('auth.most_used_apps')}
                </Typography>
                <Stack direction="row" spacing={4} alignItems="center" justifyContent="center" sx={{ my: 2, mb: 3 }}>
                    <Box display="flex" flexDirection="column" alignItems="center">
                        {/* eslint-disable-next-line i18next/no-literal-string */}
                        <img src={GoogleAuthenticatorLogo} alt="Google Authenticator" width={80} height={80} />
                        <Typography variant="caption">{t('auth.google_authenticator')}</Typography>
                    </Box>
                    <Box display="flex" flexDirection="column" alignItems="center">
                        {/* eslint-disable-next-line i18next/no-literal-string */}
                        <img src={MicrosoftAuthenticatorLogo} alt="Microsoft Authenticator" width={80} height={80} />
                        <Typography variant="caption">{t('auth.microsoft_authenticator')}</Typography>
                    </Box>
                </Stack>
                <Typography variant="body1" gutterBottom>
                    {t('auth.find_code_in_app')}
                </Typography>
                <Typography variant="body1" gutterBottom>
                    {t('auth.enter_code')}
                </Typography>
                <Typography variant="body1" gutterBottom>
                    {t('auth.no_code_contact')}
                </Typography>
            </DialogContent>
        </Dialog>
    )
}

export default ExplainAuthenticatorDialog
